import React from "react";
import { motion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import cls from "./HalykSection.module.css";

import halyk1 from '../assets/halyk1.png'
import halyk2 from '../assets/halyk2.png'
import satbayevBg from '../assets/s_bg.png'

interface HalykSectionProps {
  isActive: boolean;
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1,
    },
  },
};

const quoteLineVariants: Variants = {
  hidden: { opacity: 0, x: -30 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const fadeUpVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const imageVariants: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const HalykSection: React.FC<HalykSectionProps> = ({ isActive }) => {
  const { t } = useTranslation();

  return (
    <Section isActive={isActive}>
      <div className={cls.spiritSection}>
        
        <motion.img 
          src={satbayevBg} 
          className={cls.absolute} 
          alt={t('halyk.altSatbayev')}
          initial={{ opacity: 0, x: -50 }}
          animate={isActive ? { opacity: 0.6, x: 0 } : { opacity: 0, x: -50 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        />

        <motion.div 
          className={cls.container}
          variants={containerVariants}
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
        >
          <h2 className={cls.staggeredQuote}>
            <motion.span className={cls.staggeredLine1} variants={quoteLineVariants}>
              {t('halyk.quoteLine1')}
            </motion.span>
            <br/>
            <motion.span className={cls.staggeredLine2} variants={quoteLineVariants}>
              {t('halyk.quoteLine2')}
            </motion.span>
          </h2>

          <motion.p className={cls.description} variants={fadeUpVariants}>
            {t('halyk.description')}
          </motion.p>

          <motion.div className={cls.imgBlock} variants={containerVariants}>
            <motion.img 
                src={halyk1} 
                alt={t('halyk.altImg')} 
                variants={imageVariants} 
            />
            <motion.img 
                src={halyk2} 
                alt={t('halyk.altImg')} 
                variants={imageVariants} 
            />
          </motion.div>

        </motion.div>
      </div>
    </Section>
  );
};

export default HalykSection;